/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */
import { CombineLatestOperator } from '../observable/combineLatest';
export function combineAll(project) {
  return function (source) {
    return source.lift(new CombineLatestOperator(project));
  };
}